import {
  AppBootstrapConfig,
} from '@refx/shared-common';

/**
 * PDT configuration for 6X airlines and 6X proxy
 */
export const SERVICING_APP_BOOTSTRAP_CONFIG_DEFAULT: Partial<AppBootstrapConfig> = {
  gatewayClientId: 'hHTGWHFDeUFVdOztQWTC7zoe63E0k8zu',
  gatewayClientSecret: 'Zw2qeL9q2LXd6Ez0',
  loggingBaseUrl: 'https://uat.digital-logging.saas.amadeus.com'
};
